export default {
  ctaLabel: {
    id: 'product_page_lpo_google_shopping_configure_cta',
    defaultMessage: 'Configure',
  },
}
